<script lang="ts">
	import { Button } from "#lib/web-ui/ui/button/index.js";
	import CameraIcon from "@lucide/svelte/icons/camera";
	import DollarSignIcon from "@lucide/svelte/icons/dollar-sign";
	import XIcon from "@lucide/svelte/icons/x";
	import ArrowRightIcon from "@lucide/svelte/icons/arrow-right";

	let {
		title,
		subTitle,
		ctaUrl,
		ctaText
	}: { title: string; subTitle: string; ctaUrl: string; ctaText: string } = $props();

	let visibleFloating = $state(true);
	let visibleDesktop = $state(true);
</script>

<!-- Desktop banner - only visible on md screens and up -->
{#if visibleDesktop}
	<div class="relative z-10 mx-auto -mb-16 hidden max-w-5xl md:block">
		<div class="-mt-12"></div>
		<div class="overflow-hidden rounded border-2 border-cyan-400 shadow-lg">
			<div class="relative bg-linear-to-r from-cyan-600 to-teal-600 px-10 py-8">
				<button
					onclick={() => (visibleDesktop = false)}
					class="absolute top-3 right-3 text-cyan-200 hover:text-white focus:outline-hidden"
					aria-label="Close"
				>
					<XIcon class="h-4 w-4" />
				</button>

				<div class="flex items-center justify-between gap-6">
					<div class="flex items-center gap-4">
						<div class="shrink-0 rounded-full bg-white p-3">
							<CameraIcon class="h-6 w-6 text-cyan-600" />
						</div>
						<div class="text-left">
							<h3 class="text-xl font-bold text-white">{title}</h3>
							<p class="mt-1 text-cyan-100">
								{subTitle}
							</p>
						</div>
					</div>
					<Button
						href="/getpaid"
						variant="secondary"
						class="min-w-52 border-0 bg-white text-cyan-700 hover:bg-cyan-50"
					>
						{ctaText}
						<ArrowRightIcon
							class="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1"
						/>
					</Button>
				</div>
			</div>
		</div>
	</div>
{/if}

<!-- Mobile floating banner - only visible on smaller screens -->
{#if visibleFloating}
	<div
		class="fixed right-0 bottom-0 left-0 z-50 mx-auto mb-4 max-w-2xl transform transition-all duration-300 ease-in-out md:hidden"
	>
		<div class="mx-4 overflow-hidden rounded border-2 border-cyan-400 shadow-xl">
			<div class="relative bg-linear-to-r from-cyan-600 to-teal-600 px-4 py-3">
				<button
					onclick={() => (visibleFloating = false)}
					class="absolute top-2 right-2 text-cyan-200 hover:text-white focus:outline-hidden"
					aria-label="Close"
				>
					<XIcon class="h-4 w-4" />
				</button>

				<div class="flex items-center justify-between">
					<div class="flex items-center gap-3">
						<div class="shrink-0 rounded-full bg-white p-2">
							<DollarSignIcon class="h-4 w-4 text-cyan-600" />
						</div>
						<div>
							<span class="text-sm font-medium text-white">Earn Extra Cash?</span>
							<span class="ml-2 hidden text-xs text-cyan-100 sm:inline">
								Get paid for photos
							</span>
						</div>
					</div>
					<Button
						href="/getpaid"
						variant="secondary"
						size="sm"
						class="mr-4 h-8 border-0 bg-white text-xs text-cyan-700 hover:bg-cyan-50"
					>
						Start Now
						<ArrowRightIcon class="ml-1 h-3 w-3" />
					</Button>
				</div>
			</div>
		</div>
	</div>
{/if}
